
import _ from 'underscore'

import service from '../service/home'
import CONSTANT from '../constant/home'

export default {
  getBillboards({ commit }) {
    return new Promise((resolve, reject) => service.getBillboards().then((list) => {
      commit(CONSTANT.BILLBOARDS_GET_LIST_SUCCESS, list)
      resolve(list)
    }, (e) => {
      commit(CONSTANT.BILLBOARDS_GET_LIST_ERROR, e)
      reject(e)
    }))
  },
  getHomeRecommend({ commit }) {
    return new Promise((resolve, reject) => service.getRecommend().then((list) => {
      commit(CONSTANT.RECOMMEND_GET_LIST_SUCCESS, list)
      resolve(list)
    }, (e) => {
      commit(CONSTANT.RECOMMEND_GET_LIST_ERROR)
      reject(e)
    }))
  },
  getBanner({ commit }) {
    return new Promise((resolve, reject) => service.getBanner().then((list) => {
      commit(CONSTANT.BANNER_GET_LIST_SUCCESS, list)
      resolve(list)
    }, (e) => {
      commit(CONSTANT.BANNER_GET_LIST_ERROR)
      reject(e)
    }))
  },
  getShops({ commit }) {
    return new Promise((resolve, reject) => service.getShops().then((list) => {
      commit(CONSTANT.SHOPS_GET_LIST_SUCCESS, list)
      resolve(list)
    }, (e) => {
      commit(CONSTANT.SHOPS_GET_LIST_ERROR)
      reject(e)
    }))
  },
  getRecommendGoods({ commit }, data) {
    return new Promise((resolve, reject) => service.getRecommendGoods(data).then((list) => {
      commit(CONSTANT.POPULAR_GET_LIST_SUCCESS, list)
      resolve(list)
    }, (e) => {
      commit(CONSTANT.POPULAR_GET_LIST_ERROR)
      reject(e)
    }))
  },
  queryQrcode({ commit }, data) {
    return new Promise((resolve, reject) => service.queryQrcode(data).then((result) => {
      commit(CONSTANT.QRCODE_QUERY_SUCCESS)
      resolve(result)
    }, (e) => {
      commit(CONSTANT.QRCODE_QUERY_ERROR)
      reject(e)
    }))
  },
  getTopicGatherList({ commit }, data) {
    return new Promise((resolve, reject) => service.getTopicGatherList(data).then((result) => {
      resolve(result)
      commit(CONSTANT.HOME_GETTOPICGATHERLIST_SUCCESS, result)
      return result
    }, (e) => {
      reject(e)
      commit(CONSTANT.HOME_GETTOPICGATHERLIST_ERROR, e)
    }))
  },
  getHomeMenus({ commit }, data) {
    return new Promise((resolve, reject) => service.getHomeMenus(data).then((result) => {
      resolve(result)
      commit(CONSTANT.HOME_GETHOMEMENUS_SUCCESS, result)
      return result
    }, (e) => {
      reject(e)
      commit(CONSTANT.HOME_GETHOMEMENUS_ERROR, e)
    }))
  },
    /*yeoman-template-point-1*/
}
